import {Route, Switch, useHistory, useLocation} from 'react-router-dom';
import {Col, Row} from "reactstrap";


const SideTabs = ({data}) => {
    let history = useHistory();
    let location = useLocation();

    const to = link => {
        if (location.pathname !== link) {
            history.push(link);
        }
    }

    const activeLink = link => {
        if (location.pathname.search(link) !== -1) {
            return 'active';
        } else {
            return '';
        }
    }

    return (
        <div className="side-tabs">
            <Row>
                <Col sm="3" xl="2">
                    <ul className="flex-column nav nav-pills">
                        {data.map(({link, icon, title}) => <li className="nav-item" key={link}>
                            <div className={`nav-link d-block ${activeLink(link)}`} onClick={() => to(link)}>
                                <i className={icon}/>
                                <p className="mb-4">{title}</p>
                            </div>
                        </li>)}
                    </ul>
                </Col>
                <Col sm="9" xl="10">
                    <Switch>
                        {data.map(({link, component}) => <Route key={link} path={link} render={() => component} />)}
                    </Switch>
                </Col>
            </Row>
        </div>
    )
};

export default SideTabs;